import { v4 as uuidv4 } from "uuid";
import logo1 from "../../assets/img/illustration/automotive.png";
import logo10 from "../../assets/img/illustration/construction.png";
import logo2 from "../../assets/img/illustration/electrical.png";
import logo3 from "../../assets/img/illustration/engineering.png";
import logo4 from "../../assets/img/illustration/industrial.png";
import logo5 from "../../assets/img/illustration/material.png";
import logo6 from "../../assets/img/brand/b6.png";
import logo7 from "../../assets/img/brand/b7.png";
import logo8 from "../../assets/img/brand/b8.png";
import logo9 from "../../assets/img/brand/b9.png";

const sponsorData = [
  {
    id: uuidv4(),
    sponsorLogo: logo1,
    name: "Automotive",
  },

  {
    id: uuidv4(),
    sponsorLogo: logo2,
    name: "Engineering",
  },

  {
    id: uuidv4(),
    sponsorLogo: logo4,
    name: "Construction",
  },

  {
    id: uuidv4(),
    sponsorLogo: logo3,
    name: "Electrical ",
  },

  {
    id: uuidv4(),
    sponsorLogo: logo5,
    name: "Industrial Equipment",
  },

  //   {
  //     id: uuidv4(),
  //     sponsorLogo: logo6,
  //   },

  //   {
  //     id: uuidv4(),
  //     sponsorLogo: logo7,
  //   },

  //   {
  //     id: uuidv4(),
  //     sponsorLogo: logo8,
  //   },

  //   {
  //     id: uuidv4(),
  //     sponsorLogo: logo9,
  //   },

  {
    id: uuidv4(),
    sponsorLogo: logo10,
    name: "Material Handling",
  },
];

export default sponsorData;
